module.exports = __webpack_public_path__ + "static/media/Trial3_wordchain.6ee266e4.mp3";